import { useEffect, useMemo } from "react";
import UploadArea from "../../pageV2/UploadArea";
import { DESIGN_STATUS, updateDesignGQL } from "../../pageV2/useDesignManagement";
import { useStore } from "store";
import { createUploadedDesignTracker } from "./uploadedDesignTracker";

const DesignUpload = () => {
  const { updateCountry } = useStore();
  const uploadedDesign = useMemo(
    () =>
      createUploadedDesignTracker({
        notifyParent: (message) => window.parent.postMessage(message, "*"),
        archiveDesign: (designId) =>
          updateDesignGQL({ designId: Number(designId), design: { status: DESIGN_STATUS.ARCHIVED } }),
      }),
    []
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const countryCode = searchParams.get("countryCode");
    if (countryCode) {
      updateCountry({
        code: countryCode,
      });
    }
  }, [updateCountry]);

  return (
    <div className="flex flex-col gap-5 w-full h-screen bg-[#F9F9FF] dark:bg-background p-2">
      <div className="w-full h-auto pl-8 pr-6 py-6 bg-white dark:bg-card rounded-lg shadow-[0px_2px_6px_0px_rgba(39,55,84,0.08)] dark:shadow-none inline-flex flex-col justify-start items-start gap-5">
        <div className="flex flex-col">
          <div className="justify-center text-slate-900 dark:text-foreground text-lg font-semibold font-['Inter'] leading-relaxed">
            Design selection
          </div>
          <div className="w-[610px] justify-start text-slate-900 dark:text-foreground text-base font-normal font-['Inter'] leading-snug">
            Please upload your PDF design file
          </div>
        </div>
        <UploadArea
          maxFileSize={50}
          acceptedFileTypes={["application/pdf"]}
          onFileUpload={uploadedDesign.onUploaded}
          onRemoveFile={uploadedDesign.onRemoved}
          genericDesignUpload={true}
        />
      </div>
    </div>
  );
};

export default DesignUpload;
